import React, { useEffect, useState } from "react";
import MultiActionAreaCard from "./MultiActionAreaCard";
import axios from "axios";
import { baseUrl } from "../../helper/urls";
import {
  Box,
  TextField,
  MenuItem,
  InputLabel,
  FormControl,
  Select,
  CircularProgress,
  Typography,
} from "@mui/material";

export default function Blog() {
  const [blogList, setBlogList] = useState([]);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true); // ⬅️ Loading state

  useEffect(() => {
    const getBlog = async () => {
      try {
        const response = await axios.get(`${baseUrl}/api/blog/getApprovedList`);
        const blogs = response.data.data;
        setBlogList(blogs);

        // Extract unique categories
        const uniqueCategories = [
          ...new Set(
            blogs.map((blog) => blog.categoryName?.trim()).filter(Boolean)
          ),
        ];
        setCategories(uniqueCategories);
      } catch (error) {
        console.log("error: ", error);
      } finally {
        setLoading(false); // ⬅️ Stop loading
      }
    };

    getBlog();
  }, []);

  useEffect(() => {
    const filtered = blogList.filter((blog) => {
      const matchesCategory =
        category === "All" ||
        blog.categoryName?.toLowerCase() === category.toLowerCase();
      const matchesSearch =
        blog.title?.toLowerCase().includes(search.toLowerCase()) ||
        blog.description?.toLowerCase().includes(search.toLowerCase());
      return matchesCategory && matchesSearch;
    });

    setFilteredBlogs(filtered);
  }, [search, category, blogList]);

  return (
    <Box sx={{ p: 3 }}>
      {/* Search + Filter Controls */}
      <Box
        sx={{
          display: "flex",
          gap: 2,
          mb: 1,
          flexWrap: "wrap",
          justifyContent: "flex-end",
        }}
      >
        <TextField
          label="Search Blog"
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <FormControl sx={{ minWidth: 150 }}>
          <InputLabel>Category</InputLabel>
          <Select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            label="Category"
          >
            <MenuItem value="All">All</MenuItem>
            {categories.map((cat) => (
              <MenuItem key={cat} value={cat}>
                {cat}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      {/* Loading Spinner or Blog Cards */}
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : filteredBlogs.length === 0 ? (
        <Typography sx={{ textAlign: "center", mt: 4 }}>
          No blogs found.
        </Typography>
      ) : (
        <MultiActionAreaCard blogList={filteredBlogs} />
      )}
    </Box>
  );
}

// import React, { useEffect, useState } from "react";
// import MultiActionAreaCard from "./MultiActionAreaCard";
// import axios from "axios";
// import { baseUrl } from "../../helper/urls";
// import {
//   Box,
//   TextField,
//   MenuItem,
//   InputLabel,
//   FormControl,
//   Select,
//   CircularProgress,
// } from "@mui/material";

// export default function Blog() {
//   const [blogList, setBlogList] = useState([]);
//   const [search, setSearch] = useState("");
//   const [category, setCategory] = useState("All");
//   const [filteredBlogs, setFilteredBlogs] = useState([]);
//   const [categories, setCategories] = useState([]);

//   useEffect(() => {
//     const getBlog = async () => {
//       try {
//         const response = await axios.get(`${baseUrl}/api/blog/getApprovedList`);
//         const blogs = response.data.data;
//         setBlogList(blogs);

//         // Extract unique categories dynamically
//         const uniqueCategories = [
//           ...new Set(
//             blogs.map((blog) => blog.categoryName?.trim()).filter(Boolean)
//           ),
//         ];
//         setCategories(uniqueCategories);
//       } catch (error) {
//         console.log("error: ", error);
//       }
//     };

//     getBlog();
//   }, []);

//   useEffect(() => {
//     const filtered = blogList.filter((blog) => {
//       const matchesCategory =
//         category === "All" ||
//         blog.categoryName?.toLowerCase() === category.toLowerCase();
//       const matchesSearch =
//         blog.title?.toLowerCase().includes(search.toLowerCase()) ||
//         blog.description?.toLowerCase().includes(search.toLowerCase());
//       return matchesCategory && matchesSearch;
//     });

//     setFilteredBlogs(filtered);
//   }, [search, category, blogList]);

//   return (
//     <Box sx={{ p: 3 }}>
//       {/* Search + Category Filter */}
//       <Box
//         sx={{
//           display: "flex",
//           gap: 2,
//           mb: 1,
//           flexWrap: "wrap",
//           justifyContent: "flex-end",
//         }}
//       >
//         <TextField
//           label="Search Blog"
//           variant="outlined"
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//         />
//         <FormControl sx={{ minWidth: 150 }}>
//           <InputLabel>Category</InputLabel>
//           <Select
//             value={category}
//             onChange={(e) => setCategory(e.target.value)}
//             label="Category"
//           >
//             <MenuItem value="All">All</MenuItem>
//             {categories.map((cat) => (
//               <MenuItem key={cat} value={cat}>
//                 {cat}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Box>

//       {/* Blog Cards */}

//       <MultiActionAreaCard blogList={filteredBlogs} />
//     </Box>
//   );
// }

// import React, { useEffect, useState } from "react";
// import MultiActionAreaCard from "./MultiActionAreaCard";
// import axios from "axios";
// import { baseUrl } from "../../helper/urls";

// export default function Blog() {
//   const [blogList, setblogList] = useState([]);

//   useEffect(() => {
//     const getBlog = async () => {
//       try {
//         const response = await axios.get(`${baseUrl}/api/blog/getApprovedList`);
//         setblogList(response.data.data);
//       } catch (error) {
//         console.log("error: ", error);
//       }
//     };

//     getBlog();
//   }, []);

//   return <MultiActionAreaCard blogList={blogList} />;
// }
